export default "__VITE_PUBLIC_ASSET__ce4fa487__"